<template>
  <el-dialog title="文件编辑" :visible.sync="formVisible" :close-on-click-modal="false">
    <el-col :span="24" style="margin-bottom: 20px;">
      <el-form :model="formData" label-width="80px" :rules="formRules" ref="formd">
        <el-form-item label="名称" prop="name">
          <el-input v-model="formData.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="fenlei">
          <el-select v-model="formData.fenlei" placeholder="选择分类">
            <el-option v-for="fl in fenleis" :key="'fl1-' + fl.Id" :label="fl.Name" :value="fl.Id + ''" />
          </el-select>
        </el-form-item>
        <el-form-item label="金额" prop="amount">
          <el-input v-model="formData.amount" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="加密">
          <div style="display:flex;">
            <el-switch v-model="formData.jm" active-color="#13ce66" inactive-color="#ff4949"
              style="margin: 10px"></el-switch>
            <el-input v-model="formData.pass" auto-complete="off" v-if="formData.jm" placeholder="请输入密码"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="formData.descpt" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <!--工具条-->
    <div slot="footer" class="dialog-footer">
      <el-button @click.native="formVisible = false">取消</el-button>
      <el-button type="primary" @click.native="formSubmit" :loading="formLoading">确认</el-button>
    </div>
  </el-dialog>
</template>


<script>
const regAmt = /^\d+(\.\d+)?$/;
const regFlnmfhs = /[`'"\\/:*?<>|]/;
export default {
  data() {
    return {
      fenleis: [],
      formVisible: false,
      formLoading: false,
      formRules: {
        name: [
          { required: true, message: '请输入参数' },
          {
            validator: (rule, v, fn) => {
              if (v != '' && regFlnmfhs.test(v)) {
                fn(new Error('格式错误：不能有特殊符号 `\'"\\/:*?等'));
                return;
              }
              fn();
            }
          }
        ], fenlei: [
          { required: true, message: '请输入参数' }
        ], amount: [
          { required: true, message: '请输入参数' },
          {
            validator: (rule, value, callback) => {
              if (value == '')
                callback(new Error('请输入金额!'));
              else if (regAmt.test(value)) {
                callback();
              } else
                callback(new Error('格式错误：必须是 "数字"'));
              // callback(new Error('格式错误：必须是 "+数字" 或者 "-数字"'));
            }
          }
        ]
      },
      //新增界面数据
      formData: {}
    }
  },
  mounted() {
    this.getFenleis();
  },
  methods: {
    show(it) {
      this.formVisible = true;
      this.formData = {
        xid: it ? it.Xid : '',
        name: it.Name,
        amount: it.Amounts,
        descpt: it.Descpt,
        fenlei: it.Fl1pro,

        jm: it.Jm == 1,
        pass: it.Pass,
      }
    },/*handleSelect:function(id){
                this.tmpltCont='';
                if(id==''){
                    return
                }
                let it=this.tmplatdatas[id];
                if(it==null){
                    return
                }
                //console.log("123",this.tmplatdatas[id]);
                this.tmpltCont=it.Content;
                this.tmpltmapls=[];
                SmsTmpltKeys(id).then(res=>{
                    for(let i in res.data){
                        this.tmpltmapls.push({
                            key:res.data[i],value:''
                        });
                    }
                });
			},*/formSubmit() {
      this.$refs.formd.validate((valid) => {
        if (valid) {
          if (this.formData.jm && this.formData.pass == '') {
            this.$message({
              message: '未填写密码',
              type: 'error'
            });
            return;
          }
          this.formLoading = true;
          this.$post('/user/fledit', this.formData).then(res => {
            console.log(res);
            this.$emit('submitOK');
            this.formLoading = false;
            this.formVisible = false;
            //this.$message('操作成功');
          }).catch(err => {
            this.$emit('submitErr', err);
            this.formLoading = false;
            //this.formVisible = false;
            this.$message({
              message: err.response ? err.response.data || '服务器错误' : '网络错误',
              type: 'error'
            });
          });
        }
      });
    }, getFenleis() {
      this.$post('/comm/fls/pro').then(res => {
        console.log('getFenleis:', res);
        this.fenleis = res.data;
      }).catch(err => {
        this.listLoading = false;
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    }
  }
};

</script>

<style scoped>
.tmpdesc {
  margin-left: 10px;
  color: #d0d0d0;
}
</style>




// WEBPACK FOOTER //
// FileEdit.vue?5049e314